import styled from '@emotion/styled'

import { black, white, grayLight20, highlightBlueDark10, highlightBlueDark30, blueDark10, redLight10, grayLight10 } from '../../constants/principles'
import { fontFamilyOpenSans, fontSize2XSmall, fontSizeSmall, fontWeightSemibold } from '../../constants/principles'

const BasicButton = styled.button`
  margin-top: 24px;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  cursor: pointer;
  padding: 12px;
  font-size: ${fontSizeSmall};
  font-weight: ${fontWeightSemibold};
  outline: none;
  ${p =>
    p.secondary
      ? `background-color:${white};
  border-color:${highlightBlueDark10};
  color:${highlightBlueDark10};`
      : `background-color:${highlightBlueDark10};
  color:white;
  border-color:${highlightBlueDark10};
  `}
  &:hover {
    background-color: ${highlightBlueDark30};
    border-color: ${highlightBlueDark30};
    ${p => p.secondary && `color:white;`}
  }
  &:disabled {
    background-color: ${grayLight10};
    cursor: not-allowed;
    border-color: ${grayLight10};
  }
`

export const PillButton = styled.button`
  ${p =>
    p.isSelected
      ? `background-color:${highlightBlueDark10};color:white;border-color:${highlightBlueDark10};`
      : `background-color:${white};border-color:${grayLight20};color:${black};  @media (any-pointer: fine) {
    &:hover {
      background-color: #e8f3ff;
      color: black;
      border-color: ${grayLight20};
    }
  }`}
  border-style: solid;
  border-radius: 14px;
  border-width: 1px;
  cursor: pointer;
  line-height: 19px;
  font-family: ${fontFamilyOpenSans};
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  border-color: ${p => p.isError && redLight10};
  &:focus {
    outline: none;
    border-color: ${highlightBlueDark30};
  }

  &:active {
    background-color: ${blueDark10};
    color: white;
    border-color: ${blueDark10};
  }
`
export const RadioButton = styled(PillButton)`
  padding: ${p => (p.isCheck && !p.isSelected ? '10px 32px;' : '10px 21px;')};
  padding: ${p => p.narrow && (p.isCheck && !p.isSelected ? '10px 22px' : '10px 11px')};
  padding: ${p => p.stackedVertically && (p.isCheck && !p.isSelected ? '14px 22px' : '14px 11px')};

  margin: 0px;
  border-radius: 0px;
  &:first-of-type {
    border-radius: ${p => (p.stackedVertically ? '14px 14px 0 0' : '14px 0 0 14px')};
  }
  &:not(:last-child) {
    ${p => (p.stackedVertically ? 'border-bottom: none' : 'border-right: none')};
  }
  &:last-child {
    border-radius: ${p => (p.stackedVertically ? '0 0 14px 14px' : '0 14px 14px 0')};
  }
  &:only-child {
    border-radius: 14px;
  }
`

export const SmallButton = styled(BasicButton)`
  font-size: ${fontSize2XSmall};
  padding: 8px;
  margin-top: 8px;
`
export default BasicButton
